import { jsx } from "react/jsx-runtime";
import compact from "lodash/compact";
import uniqueId from "lodash/uniqueId";
import { classes } from "./CoreDropdownOption.st.css";
const createOption = (option = null) => ({
  id: option && (option.id || option.id === 0) ? option.id : uniqueId("Option"),
  isDisabled: false,
  isSelectable: true,
  value: null,
  render: (val) => /* @__PURE__ */ jsx("div", { className: classes.title, role: "presentation", children: val }),
  ...option
});
const escapeRegExp = (s) => s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
const highlightRegExt = (s) => new RegExp(`(${s.replace(/ /g, "|")})`, "gi");
const isEven = (i) => i % 2 === 0;
const isOdd = (i) => i % 2 === 1;
const highlightMatches = (option, searchTerm) => {
  const regExp = highlightRegExt(escapeRegExp(searchTerm.trim()));
  const stringArray = option.value.split(regExp);
  const f = stringArray[0] === "" ? isEven : isOdd;
  const parts = compact(stringArray).map(
    (part, i) => f(i) ? /* @__PURE__ */ jsx("mark", { className: classes.highlight, children: part }, i) : /* @__PURE__ */ jsx("span", { className: classes.nonHighlight, children: part }, i)
  );
  return createOption({
    id: option.id,
    isDisabled: option.isDisabled,
    isSelectable: option.isSelectable,
    value: option.value,
    render: () => option.render(parts)
  });
};
const OptionFactory = {
  create: createOption,
  createHighlighted(option, highlightValue) {
    return option.value && highlightValue ? highlightMatches(option, highlightValue) : option;
  }
};
export {
  OptionFactory
};
//# sourceMappingURL=OptionFactory.js.map
